import React from 'react';
import { Tooltip, Typography, Stack } from '@mui/material';
import { InfoIcon } from './Icons/Icons';
import { AppColors } from '../Utils/helper/AppColors';
import { getColorSettings } from '../Utils/helper/commonUtils';


export default function CustomInfoTooltip({
	title,
	iconSize = 20,
	placement,
	iconColor ,
	children, // NEW: allow custom children
}) {
	
	const localSettingColors = getColorSettings();

	return (
		<Tooltip
			slotProps={{
				tooltip: {
					sx: (theme) => ({
						bgcolor: theme.palette.primary.lightest_shade,
						color: theme.palette.primary.darker_primary,
						boxShadow: '0 0 4 0 #B9B9F780',
						radius: '5px',
						// border: `1px solid ${theme.palette.primary.lightest_shade}`,
					}),
				},
				
			}}
			arrow
			placement={placement || 'right'}
			title={
				<Typography
					sx={(theme) => ({
						fontSize: 14,
						color: theme.palette.primary.darker_primary,
						fontFamily: 'Poppins',
						fontWeight: 500,
						lineHeight: '121%',
						whiteSpace: 'pre-line',
					})}
					lineHeight={'150%'}
				>
					{title}
				</Typography>
			}
		>
			{/* If children provided, use them, else show InfoIcon */}
			<Stack>{children ? children : <InfoIcon size={iconSize} color={iconColor || localSettingColors.fontColor} />}</Stack>
		</Tooltip>
	);
}
